module.exports = __webpack_public_path__ + "img/About_Freelancers_LIGHT-01.aef7a76.svg";